style= require('./prices.styl')
- var moment = require('moment')
- const PlayerPointsTable = require('./player-points-table.jade')

if isLoading
  .loading
    h1 Prices are Loading...
    h1 Please wait
else
  .header-filters
    .filters_xGoals
      .filters
        if this.seasons
          .row
            ft-dropdown.dropdown(icon)
              header.dropdown-header(slot="header")
                if this.sport
                  .dropdown-icon
                    ft-icon(name=`sports--${this.sport}`)
                span.dropdown-text=(this.sport) || 'All sports'
              each s in this.listSports
                .dropdown-item(role='option', value=s, (click)=this.changeSport(s),selected=(s == this.sport))
                  if s
                    .dropdown-icon
                      ft-icon(name=`sports--${s}`)
                  span= s

            sporty-seasons(
              season=season,
              sport= this.sport,
              (change:season)=this.changeSeason(e),
              blank="Select a season"
            )

            ft-dropdown.dropdown(icon)
              header.dropdown-header(slot="header")
                if this.team
                  .dropdown-icon
                    img(src= this.team.iconUrl)
                span.dropdown-text=( this.team &&  this.team.name) || ' Unpriced players'
              each team in teams
                .dropdown-item(role='option', value=team.name, (click)=this.changeTeam(team), selected=this.team === team)
                  .dropdown-icon
                    img(src=team.iconUrl)
                  span= team.name
            ft-form-field.match
              .match-header
                select.match-items((change)=this.changeMatch(e.target.value))
                  option(value="") Pick a match
                  each status, index in this.matchStatuses
                    optgroup(label=status.status,class=status.status)
                    each match, index in status.sortedMatches
                      option(value=match._id selected=this.match === match)= match.descriptor
                ft-icon.down(name='ui--chevron')
            ft-dropdown.dropdown(icon)
              header.dropdown-header(slot="header")
                span.dropdown-text=( this.pickedGameweek && this.pickedGameweek.label) || 'Pick game week'
              each gw, index in this.gameweeks
                .dropdown-item(role='option', value=gw.value, (click)=this.changeGameweek(gw), selected=this.pickedGameweek === gw)
                  span= gw.label
            if match && match.xprices && match.xprices.length
              ft-dropdown.dropdown(icon)
                header.dropdown-header(slot="header")
                  span.dropdown-text= priceScope?.scope || 'Pick Price Scope'
                .dropdown-item(
                  role='option',
                  value=null,
                  (click)=this.changePriceScope(null),
                  selected=!this.priceScope)
                    span None
                each scope in match.xprices
                  .dropdown-item(
                    role='option',
                    value=scope.scope,
                    (click)=this.changePriceScope(scope),
                    selected=this.priceScope === scope)
                      span= scope.scope

          if season && match
            .row
              .expected
                label.label Home
                sporty-form-field([(value)]=this.xGoalValues.home)
                  input(
                    type="number",
                    step="0.1",
                    min="0",
                  )
              .expected
                label.label Draw
                sporty-form-field([(value)]=this.xGoalValues.draw)
                  input(
                    type="number",
                    step="0.1",
                    min="0",
                  )
              .expected
                label.label Away
                sporty-form-field([(value)]=this.xGoalValues.away)
                  input(
                    type="number",
                    step="0.1",
                    min="0",
                  )
            .row
              .expected
                label.label Over
                sporty-form-field([(value)]=this.xGoalValues.over)
                  input(
                    type="number",
                    step="0.1",
                    min="0",
                  )
              .expected
                label.label Under
                sporty-form-field([(value)]=this.xGoalValues.under)
                  input(
                    type="number",
                    step="0.1",
                    min="0",
                  )
              .expected
                label.label Score
                sporty-form-field([(value)]=this.xGoalValues.score)
                  input(
                    type="number",
                    (focusout)=this.validate(value),
                    min="0",
                  )
              .expected
                .button.generate-goals((click) = this.getXGoalResult)= 'Compute XG'
              .expected
                label.label Recommended budget
                sporty-form-field([(value)]=recommendedBudget)
                  input(
                    type="number",
                    step="0.1",
                  )
              .expected
                label.label xFP quantile
                sporty-form-field([(value)]=this.xfpQuantile)
                  input(
                    type="number",
                    step="0.1",
                  )
              .expected
                label.label xFP ratio
                sporty-form-field([(value)]=this.convertionXfpRatio)
                  input(
                    type="number",
                    step="0.1",
                  )
              .expected
                .button.generate-goals((click) = this.xFPtoPrice())= 'Compute prices'
              if hasFeedPrices
                .expected
                  .button.generate-prices((click) = this.generatePricesFromFeed())= 'Compute prices from feed'
              .expected
                label.label Multiplier
                sporty-form-field([(value)]=this.xPriceConversionFactor)
                  input(
                    type="number",
                    step="0.1",
                  )
              .expected
                label.label Name
                sporty-form-field([(value)]=this.xPriceConversionName)
                  input(type="text")
              .expected
                .button.generate-goals((click)=this.xPriceConvert(this.match, this.xPriceConversionFactor, this.xPriceConversionName))= 'Convert Xprices'
              .expected
                .button.generate-goals((click)=this.xPriceReverse(this.match, this.xPriceConversionFactor, this.xPriceConversionName))= 'Convert to GW'

      if season && match
        .match-tile_averages
          sporty-status.sporty-status(match=match)
          .column
            if season?.isDuel
              - season.averagePrice || (season.averagePrice = 8)
              .expected
                label.label Average price
              .expected
                sporty-form-field([(value)]=season.averagePrice)
                  input(
                    type="number",
                    step="0.1",
                    min="0",
                  )
              - season.averageGoals || (season.averageGoals = 0)
              .expected
                label.label Average goals
              .expected
                sporty-form-field([(value)]=season.averageGoals)
                  input(
                    type="number",
                    step="0.1",
                    min="0",
                  )
            ft-button.button(
            accent,
            bloat,
            success,
            (click)=this.save()
            ) Save
    if season && match
      .upload_download
        form.csv(
          ref="season-csv",
          id="season-csv",
          method="POST"
          action=uploadSeasonCsvPath,
          encType="multipart/form-data"
          )
          a.download(href=downloadSeasonCsvPath)
            ft-icon(name=`ui--download`)
            span DL Full CSV
          .upload((click) = this.isUploading())
            ft-icon(name=`ui--download`)
            span UL Full File
          if this.upload
            input(type="file" name="csv" accept=".csv")
            input(type="submit")
        .send-fixtures
          ft-button(success,
            disabled=season?.$isSubmitting,
            (click)=this.send(season, 'fixtures')
          )='Send Fixtures'
          ft-button(success,
            disabled=season?.$isSubmitting,
            (click)=this.send(season, 'prices', match)
          )='Send Prices'
          ft-button(href=`/matches/${match._id}/price-feeds`)
            | Download Feed
          for source in projectionSources
            ft-button.button(
              warning,
              (click)=this.scrape('projections', source)
            )= `Get Projections: ${this.getSourceName(source)}`
          for source in priceSources
            ft-button.button(
              warning,
              (click)=this.scrape('prices', source)
            )= `Get Prices: ${this.getSourceName(source)}`
  section.teams-container(class={nonduel: !season?.isDuel})
    each team, i in listedTeams
      .team(class=season?.isDuel && ['home', 'away'][i])
        .filtre-items
          .team-info
            .expected-goals
              img.team-icon(src=match.iconUrl)
              h3= team.name
              if season?.isDuel
                label.label Expected goals
                sporty-form-field.input([(value)]= this.match.expectedGoals[i])
                  input(
                    type="number",
                    step=0.01,
                    min="0",
                    (focusout)=this.getOddsResult
                )
            .team-average-factor.expected
              label.label Team factor
              .value=`avg ${this.averageTeamFactor(team, 'factor')}`
          .mass-pricing
            if this.approvedLeagues.includes(season.name)
              .button(
                primary,
                (click)=this.setAllMatchPrices(team, modPosition, mods[i])
              ) Set all prices to mod value
          .controls
            .filters
              section.controls
                input(
                  type="search",
                  placeholder="Name, team, shirt, position",
                  (input)=this.updateFilter(e))
                - const sortedPlayers = this.sortedPlayers(team).length
                label.label
                  = `Available only: ${sortedPlayers}`
                ft-toggle(
                  checked=this.available,
                  (toggle)=this.toggleAvailable()
                )
                if hasRemarks
                  label.label Remarks
                  ft-toggle(
                    checked=this.showRemarks,
                    (toggle)=this.showRemarks = !this.showRemarks
                  )
              section.controls
                select((change)=this.render(this.modPosition = e.target.value))
                  option(value="") All positions
                  each position in positions
                    option(
                      value=position,
                      selected=position === modPosition
                    )= position
              .mod-percentage
                label.label.mod= 'Mod. Percentage'
                .controls
                  sporty-form-field([(value)]=mods[i])
                    input(
                      placeholder='%'
                      type='number',
                    )
                  .button(
                    primary,
                    (click)=this.modify(team, modPosition, mods[i])
                  ) Modify
            .copy_generate
              section.controls
                if team.isPlayerPointsView
                  ft-button.button(
                    (click)=this.savePlayerPoints(team)
                    warning,
                  ) Save Player Points
                  ft-button.button(
                    (click)=this.togglePlayerPointsView(team)
                    warning,
                  ) Back
                else
                  if isFactorCopy(season)
                    ft-button.button(
                      warning,
                      (click)=this.copy(team, 'factor')
                    ) Copy Factors
                  else
                    ft-button.button(
                      warning,
                      (click)=this.copy(team, 'price')
                    ) Copy Prices
                  ft-button.button(
                    warning,
                    (click)=this.generate(team)
                  ) Generate
                  ft-button.button(
                    (click)=this.togglePlayerPointsView(team)
                    warning,
                  ) Set Player Points
        if team.isPlayerPointsView
          +PlayerPointsTable(parent=this, season=season, team=team)
        else
          .prices(class={ remarks: showRemarks && hasRemarks })
            if season && match && player
              section.control
                ft-button.button(
                  warning,
                  (click)=this.copy(team, 'price'),
                ) Copy Prices
            .player.header(class=season.sport)
              .shirt.sortable(
                (click)=this.sortBy('shirt'),
                class={ sorted: this.sort === 'shirt' },
                )
                | #
                ft-icon(name=categoryIcon('shirt', this.sort, this.reverse))
              .name.sortable(
                class={sorted: !this.sort || this.sort === 'name'},
                (click)=this.sortBy('name')
                )
                | Name
                ft-icon(name=categoryIcon('name', this.sort, this.reverse))
              if season?.isDuel
                .position Pos
              .disabled
                label N/A
              .status Status
              if this.season.league.sport === 'basket'
                .statistics.sortable(
                    title='Projected Minutes',
                    (click)=this.sortBy('average_minutes'),
                    class={ sorted: this.sort === 'average_minutes' }
                )= 'PM'
                  ft-icon(name=categoryIcon('average_minutes', this.sort, this.reverse))
              if this.seasonMatches && this.statsFields[this.season.league.sport]
                each stat in this.statsFields[this.season.league.sport]
                  .statistics.sortable(
                    title=stat.title,
                    (click)=this.sortBy(stat.key),
                    class={ sorted: this.sort === stat.key }
                  )= stat.short_title
                    ft-icon(name=categoryIcon(stat.key, this.sort, this.reverse))
              if showRemarks && hasRemarks
                .season-price Remarks
              else if priceScope
                .season-price.sortable(
                  class={sorted: this.sort === 'xprice'},
                  (click)=this.sortBy('xprice')
                )
                  = priceScope.scope
                  ft-icon(name=categoryIcon('seasonPrice', this.sort, this.reverse))
              else
                .season-price.sortable(
                  class={sorted: this.sort === 'seasonPrice'},
                  (click)=this.sortBy('seasonPrice')
                )
                  | S. Price
                  ft-icon(name=categoryIcon('seasonPrice', this.sort, this.reverse))
              if season?.isDuel
                .factor-wrap
                  .factor.sortable(
                    class={sorted: this.sort === 'factor'},
                    (click)=this.sortBy('factor')
                  )
                    | Factor
                  ft-icon(name=categoryIcon('factor', this.sort, this.reverse))
              .price.sortable(
                class={sorted: this.sort === 'gameweekPrice'},
                (click)=this.sortBy('gameweekPrice')
              )
                | Price
                ft-icon(name=categoryIcon('gameweekPrice', this.sort, this.reverse))
            .player.odd(class=season.sport)
              .shirt
              .short-name= team.name
              .position (All)
              .disabled
                ft-toggle(
                  checked=isAllDisabled(team),
                  (toggle)=this.toggleAllPrices(team, e)
                )
            ft-pagination(
              current=pages[team] || 0,
              size=50,
              total=this.filteredPlayers(team).length,
              display=5,
              border,
              (currentChanged)=this.changePage(team, e.current)
            )
            each player, j in this.sortedPlayers(team)
              - var price = this.priceFor(player)
              .player(class={odd: j % 2, injured: player?.status && player?.status != 'available', [season.sport]: true})
                .shirt
                  if player.shirt || player.shirt === 0
                    = player.shirt
                .short-name(title=player.fullName)= player.name
                if season?.isDuel || this.season.league.sport === 'eurovision'
                  .position  (#{player.pos})
                .disabled
                  ft-toggle(
                    checked=price.disabled,
                    (toggle)=this.togglePrice(prices[player], e)
                  )
                .status
                  select(
                    value=price.status || 'available',
                    [value]=price.status || 'available',
                    (change)=(
                      prices[player].status = e.target.value,
                      this.initializeStatus(player),
                      this.render()
                    )
                  )
                    each status in statuses
                      option(
                        value=status
                        selected=price.status === status
                      )= status
                if this.season.league.sport === 'basket'
                  - var average_minutes = this.getStat(player, { key: 'average_minutes '})
                  sporty-form-field(
                    [value]=average_minutes,
                    (change)=this.renderStats(e.target.value, player)
                  )
                    input(
                      type="number",
                      step=0.01,
                      min="0"
                    )
                if this.seasonMatches && this.statsFields[this.season.league.sport]
                  each stat in this.statsFields[this.season.league.sport]
                    .statistics= this.getStat(player, stat)
                if price.disabled
                  .season-price
                    input(
                      type="number",
                      value=0,
                      disabled
                    )
                  if season?.isDuel
                    .factor
                      input(
                        type="number",
                        [value]=0,
                        disabled
                      )
                  .price
                    input(
                      type="number",
                      [value]=0,
                      disabled
                    )
                else
                  - prices[player].prices[match] || (prices[player].prices[match] = {})
                  .season-price
                    each remark in remarks
                      if remark.type === 'select'
                        select(
                          value=price[remark.field],
                          [value]=prices[player][remark.field],
                          (change)=prices[player][remark.field] = e.target.value,
                          disabled=!canEditPrice(user))
                          each option in remark.options
                            option(
                              value=option,
                              selected=prices[player][remark.field] === option
                            )= option
                      else if remark.type === 'priceScope'
                        input(
                          type="number",
                          value= priceScope.prices[player._id],
                          (change)=changeScopePrice(player, e.target.value),
                          disabled=!canEditPrice(user))
                      else
                        - price[remark.field] || (price[remark.field] = 0)
                        sporty-form-field([(value)]=prices[player][remark.field])
                          input(
                            type="number",
                            step=0.1,
                            min="0",
                            disabled=!canEditPrice(user))
                  if season?.isDuel
                    .factor
                      sporty-form-field([(value)]=prices[player].prices[match].factor)
                        input(
                          type="number",
                          step=0.01,
                          min="0",
                          disabled=!canEditPrice(user))
                  .price
                    sporty-form-field([(value)]=prices[player].prices[match].price)
                      input(
                        type="number",
                        step=0.1,
                        min="0",
                    )
  if season && (team && team._id === 'priced-players')
    .unassigned-prices
      if season?.isDuel
        .button(
          primary,
          (click)=this.generatePriced()
        ) Generate
      .player
        .team.sortable(
          class={ sorted: this.sort === 'team' },
          (click)=this.sortBy('team')
        )
          | Team
          ft-icon(name=categoryIcon('team', this.sort, this.reverse))
        .shirt #
        .short-name.sortable(
          class={ sorted: this.sort === 'fullName' },
          (click)=this.sortBy('fullName')
        )
          | Name
          ft-icon(name=categoryIcon('fullName', this.sort, this.reverse))
        if season?.isDuel
          .position.sortable(
            class={ sorted: this.sort === 'pos' },
            (click)=this.sortBy('pos')
          )
            | Pos
            ft-icon(name=categoryIcon('pos', this.sort, this.reverse))
        .match-gw.sortable(
          class={ sorted: this.sort === 'round' },
          (click)=this.sortBy('round')
        )
          | GW
          ft-icon(name=categoryIcon('round', this.sort, this.reverse))
        .disabled N/A
        .statistics.sortable(
          class={sorted: this.sort === 'fp'},
          (click)=this.sortBy('fp')
        )
          | Fantasy Points
          ft-icon(name=categoryIcon('fp', this.sort, this.reverse))
        .season-price.sortable(
          class={ sorted: this.sort === 'seasonPrice' },
          (click)=this.sortBy('seasonPrice')
        )
          | Season Price
          ft-icon(name=categoryIcon('seasonPrice', this.sort, this.reverse))
        if season?.isDuel
          .factor.sortable(
            class={ sorted: this.sort === 'factor' },
            (click)=this.sortBy('factor')
          )
            | Factor GW
            ft-icon(name=categoryIcon('factor', this.sort, this.reverse))

        .price.sortable(
          class={ sorted: this.sort === 'price' },
          (click)=this.sortBy('price')
        )
          | Price GW
          ft-icon(name=categoryIcon('price', this.sort, this.reverse))

      each priced, j in sortPriced()
        - var player = priced.player
        - var shirt = player.shirt || player.shirt === 0 ? player.shirt : '?'
        - var price = this.priceFor(priced)
        .player(class={ odd: j % 2 })
          .team= player.team && player.team.name
          .shirt= shirt + '.'
          .name= player.fullName
          if season?.isDuel
            .position (#{player.pos})
          .match-gw= priced.round
          .disabled
            ft-toggle(
              checked=priced.disabled,
              (toggle)=this.togglePriced(priced)
            )
          .statistics= priced.fp
          .season-price
            - priced.seasonPrice || (priced.seasonPrice = 0)
            sporty-form-field([(value)]=priced.seasonPrice)
              input(
                type="number",
                step=0.1,
                min="0",
              )
          .factor
            - player.factor == null && (priced.factor = 1)
            sporty-form-field([(value)]=priced.factor)
              input(
                type="number",
                step=0.01,
                min="0",
              )
          .price
            - priced.price || (priced.price = 0)
            sporty-form-field([(value)]=priced.price)
              input(
                type="number",
                step=0.1,
                min="0",
              )
      .button(
        bloat,
        success,
        (click)=this.save()
      ) Save

  if season && !team
    .unassigned-prices
      if season?.isDuel
        .button(
          primary,
          (click)=this.generateUnpriced()
        ) Generate
      .player
        .team Team
        .shirt #
        .short-name Name
        if season?.isDuel
          .position Pos
        .status Status
        if season?.isDuel
          .match-opponent Opponent
        .match-start Starts
        .match-gw GW
        .disabled N/A
        .season-price Season Price
        if season?.isDuel
          .factor Factor GW
        .price Price GW
      each player, j in unpriced
        - var price = this.priceFor(player)
        .player(class={odd: j % 2})
          .team= player.team && player.team.name
          .shirt= (player.shirt || '?') + '.'
          .name= player.name
          if season?.isDuel
            .position (#{player.pos})
          .status
            select(
              value=price.status || 'available',
              [value]=price.status || 'available',
              (change)=(prices[player].status = e.target.value, this.render())
            )
              each status in statuses
                option(
                  value=status
                  selected=price.status === status
                )= status
          - var match = (this.nextMatch || {})[player.team]
          if match && season?.isDuel
            - var opposing = match.opposing(player.team)
            .match-opponent= opposing && opposing.name
          if match
            .match-start= moment(match.startTime).format('ll')
            .match-gw= match.round
          else
            .no-match No match
          .start No time
          .gw No GW
          .disabled
            ft-toggle(
              checked=price.disabled,
              (toggle)=this.toggle(prices[player])
            )
          .season-price
            - price.seasonPrice || (price.seasonPrice = 0)
            sporty-form-field([(value)]=prices[player].seasonPrice)
              input(
                type="number",
                step="0.1",
                min="0",
            )
          if match && season?.isDuel
            .factor
              - price.factors[match.round] == null && (price.factors[match.round] = 1)
              sporty-form-field([(value)]=prices[player].prices[match].factor)
                input(
                  type="number",
                  step=0.01,
                  min="0",
              )
          if match
            .price
              - price.prices[match.round] || (price.prices[match.round] = 0)
              sporty-form-field([(value)]=prices[player].prices[match].price)
                input(
                  type="number",
                  step=0.1,
                  min="0",
              )
          else
            .no-match
      .button(
        bloat,
        success,
        (click)=this.save()
      ) Save
